import { Amplify } from "aws-amplify";
import AWS from "aws-sdk";

const Configration = (function () {
  var application = "";
  var userPoolId = "";
  var identityPoolId = "";
  var selectedCatalog = "test";
  var selectedSchema = "test";
  var user = { jwt: "" };

  var getName = function () {
    return application; // Or pull this from cookie/localStorage
  };

  var getToken = function () {
    return user.jwt; // return jwt token
  };

  var setCatalog = function (catalog) {
    selectedCatalog = catalog; // return database catalog
  };

  var setSchema = function (schema) {
    selectedSchema = schema; // return database schema
  };

  var getCatalog = function () {
    return selectedCatalog; // return database catalog
  };

  var getSchema = function () {
    return selectedSchema; // return database schema
  };

  var configure = function (name, region, poolid, clientid, identity_pool) {
    application = name;
    userPoolId = poolid;
    identityPoolId = identity_pool;
    // Configure Amplify in index file or root file
    Amplify.configure({
      Auth: {
        region: region,
        userPoolId: poolid,
        userPoolWebClientId: clientid,
      },
    });

    AWS.config.region = region; // Region
  };

  var setUserCredentials = function (idToken) {
    user = {
      jwt: idToken.jwtToken,
      sub: idToken.payload.sub,
      name: idToken.payload.name,
      email: idToken.payload.email,
    };

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: identityPoolId,
      Logins: {
        [`cognito-idp.${AWS.config.region}.amazonaws.com/${userPoolId}`]:
          idToken.jwtToken,
      },
    });
  };

  return {
    getCatalog: getCatalog,
    getSchema: getSchema,
    getName: getName,
    getToken: getToken,
    configure: configure,
    setCatalog,
    setSchema,
    setUserCredentials,
  };
})();

export default Configration;
